import { AbstractControl, ValidatorFn, AsyncValidatorFn, ValidationErrors } from '@angular/forms';
import { Observable, timer } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';
import { MfkService } from '../services';
import { Mfk, ValidatedMfk } from '@uiowa/uiowa-mfk';

export class MfkValidator {
    public static fieldLengths = (): ValidatorFn => {
        return (control: AbstractControl): { [key: string]: boolean } => {
            var mfk = control.value as Mfk;
            if (
                mfk.fund == null ||
                    mfk.org == null ||
                    mfk.dept == null ||
                    mfk.subdept == null ||
                    mfk.grantpgm == null ||
                    mfk.iact == null ||
                    mfk.oact == null ||
                    mfk.dact == null ||
                    mfk.fn == null ||
                    mfk.cctr == null ||
                    mfk.fund.length !== 3 ||
                    mfk.org.length !== 2 ||
                    mfk.dept.length !== 4 ||
                    mfk.subdept.length !== 5 ||
                    mfk.grantpgm.length !== 8 ||
                    mfk.iact.length !== 4 ||
                    mfk.oact.length !== 3 ||
                    mfk.dact.length !== 5 ||
                    mfk.fn.length !== 2 ||
                    mfk.cctr.length !== 4
            ) {
                return { fieldLength: true };
            }
            return null;
        }
    }

    public static validateCashnetDepositIacct = (): ValidatorFn => {
        return (control: AbstractControl): { [key: string]: boolean } => {
            var mfk = control.value as Mfk;
            var orgs = ['03', '17', '65', '66', '70', '80', '85', '87', '89', '93', '94'];
            if (orgs.includes(mfk.org)) {
                if (mfk.iact != '1100' && mfk.iact != '1120' && mfk.iact.substr(0, 1) !== "4") {
                    return { invalidUIHCIacct: true };
                }
            } else if (mfk.iact.substr(0, 1) !== "4") {
                return { invalidIacct: true };
            }
            if (mfk.iact === "4598") {
                return { invalid4598Iacct: true };
            }
            return null;
        }
    }

    public static validate = (mfkService: MfkService): AsyncValidatorFn => {
        return (control: AbstractControl): Observable<ValidationErrors | null> => {
            return timer(500)
                .pipe(switchMap(() => mfkService.validateMfk(control.value)))
                .pipe(map((validateMfkResult: ValidatedMfk) => {
                        if (validateMfkResult.valid) {
                            return null;
                        } else {
                            return { invalid: { message: validateMfkResult.statusMessage } };
                        }
                    })
                );
        }
    }
}